(ns url.scope
  "Whether links are in scope of a page — the page itself, the site it is on,
   or everywhere — where a page is `{:url :resource-key}`."
  (:require
   [url.core :as url]
   [url.resource :as resource]))

(defn in-scope?
  "Whether something linked to `urls` is in `scope` for `page`. The page is the
   exact address; the site is the page and every address on its resource-key."
  [scope {page-url :url :keys [resource-key] :as page} urls]
  (case scope
    :scope/all true
    :scope/page (boolean (some #(url/same-page? page-url %) urls))
    :scope/site (boolean (or (in-scope? :scope/page page urls)
                             (and resource-key
                                  (some #(= resource-key (resource/url->resource-key %)) urls))))))

(defn link-match
  "Where `link-url` sits against `page`: on it (`:page`), elsewhere on its site
   (`:site`), or neither (nil)."
  [page link-url]
  (cond
    (in-scope? :scope/page page [link-url]) :page
    (in-scope? :scope/site page [link-url]) :site))
